"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderSvgSprite = void 0;
function renderSvgSprite(spriteUrl, className = '') {
    return `
    <svg class="${className}">
      <use xlink:href="${spriteUrl}"></use>
    </svg>
    `;
}
exports.renderSvgSprite = renderSvgSprite;
